

const EntrepriseReducer = (state, action) => {
    switch (action.type) {
        case "GET_ENTREPRISES_START":
            return {
                ...state,
                entreprises: [],
                isFetching: true,
                error: false,
            };
        case "GET_ENTREPRISES_SUCCESS":
            return {
                ...state,
                entreprises: action.payload.entreprises,
                count: action.payload.count,
                isFetching: false,
                error: false,
            };
        case "GET_ENTREPRISES_FAILURE":
            return {
                ...state,
                entreprises: [],
                isFetching: false,
                error: action.payload,
            };
        case "ADD_ENTREPRISE_START":
            return {
                ...state,
                entreprise: {},
                isFetchingAdd: true,
                errorAdd: false,
            };
        case "ADD_ENTREPRISE_SUCCESS":
            return {
                ...state,
                entreprise: action.payload.entreprise,
                isFetchingAdd: false,
                errorAdd: false,
            };
        case "ADD_ENTREPRISE_FAILURE":
            return {
                ...state,
                entreprise: {},
                isFetchingAdd: false,
                errorAdd: action.payload,
            };
        case "UPDATE_ENTREPRISE_START":
            return {
                ...state,
                entreprise: {},
                isFetchingUpdate: true,
                errorUpdate: false,
            };
        case "UPDATE_ENTREPRISE_SUCCESS":
            return {
                ...state,
                entreprise: action.payload.entreprise,
                isFetchingUpdate: false,
                errorUpdate: false,
            };
        case "UPDATE_ENTREPRISE_FAILURE":
            return {
                ...state,
                entreprise: {},
                isFetchingUpdate: false,
                errorUpdate: action.payload,
            };
        case "ACTIVATE_ENTREPRISE_START":
            return {
                ...state,
                entreprise: {},
                isFetchingActivate: true,
                errorActivate: false,
            };
        case "ACTIVATE_ENTREPRISE_SUCCESS":
            return {
                ...state,
                entreprise: action.payload.entreprise,
                isFetchingActivate: false,
                errorActivate: false,
            };
        case "ACTIVATE_ENTREPRISE_FAILURE":
            return {
                ...state,
                entreprise: {},
                isFetchingActivate: false,
                errorActivate: action.payload,
            };
        case "GET_ENTREPRISES_MINI_SUCCESS":
            return {
                ...state,
                entreprisesMini: action.payload.entreprises,
            };
        default:
            return { ...state };
    }
}

export default EntrepriseReducer;